import React from "react";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";

import ls from "local-storage";
import * as CONFIG from "./_config";
import RV from "simple-react-validator";

import "./css/error.css";

//import background from "./../../public/assests/images/foodbazaarloginimage.png";

toast.configure();

class Error extends React.Component {
  constructor(props) {
    super(props);
    this.validator = new RV();
    this.validator.visibleFields = [];
    this.state = {
      formControls: {
        username: "",
        password: "",
      },
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.Login();
    }
  }

  componentDidMount() {
    if (ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`)) {
      window.location.href = "/";
    }
  }

  render() {
    return (
      <div>
        <div className="main-container full-width pt-2 mt-2  ">
          {CONFIG.DATA.THEME === 2 ? (
            <div>
              {CONFIG.DATA.BACKEND_HOST === "foodbazaar" ? (
                ""
              ) : (
                <section
                  id="apus-breadscrumb"
                  className="breadcrumb-page apus-breadscrumb"
                  style={{ backgroundColor: "#f3ffd9" }}
                >
                  <div className="container">
                    <div className="wrapper-breads">
                      <div className="wrapper-breads-inner">
                        <div className="breadscrumb-inner">
                          <h2 className="bread-title">Login</h2>
                          <ol className="breadcrumb">
                            <li>
                              <a href={CONFIG.DATA.BASEPATH}>Home</a>
                            </li>
                            <li>
                              <span>Login</span>
                            </li>
                          </ol>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              )}
            </div>
          ) : (
            <div className="title-breadcrumb">
              <div className="container">
                <div className="title-breadcrumb-inner">
                  <header className="entry-header">
                    <h1 className="entry-title">ERROR</h1>
                  </header>
                </div>
              </div>
            </div>
          )}

          <div className="row" style={{ margin: "0 auto" }}>
            <div className="col-md-6 offset-md-3 pt-4">
              {CONFIG.DATA.BACKEND_HOST === "foodbazaar" ? (
                <div className="card">
                  <div className="card-body">
                    <h3 style={{ fontWeight: "400" }}>404</h3>
                  </div>
                </div>
              ) : (
                ""
              )}
              {/* <div className="page-content border pt-3">
                <div className="container">
                  <article
                    id="post-22"
                    className="post-22 page type-page status-publish hentry"
                  >
                    <div className="entry-content">
                      <div className="woocommerce">
                        <div className="woocommerce-notices-wrapper"></div>

                        <p>404 ERROR</p>
                        <br />

                        <p>PAGE NOT FOUND</p>
                      </div>
                    </div>
                  </article>
                </div>
              </div> */}

              <section class="page_404">
                <div class="container">
                  <div class="row">
                    <div class="col-sm-12 ">
                      <div class="col-sm-10 col-sm-offset-1  text-center">
                        <div class="four_zero_four_bg">
                          <h1 class="text-center ">404</h1>
                        </div>

                        <div class="contant_box_404">
                          <h3 class="h2">PAGE NOT FOUND</h3>

                          <p>the page you are looking for not avaible!</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default Error;
